import { useCallback } from 'react';
import { STUDIO_THEMES } from 'fym-shared/src/music24/studioThemes';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { setPendingStudioParams } from '../draftStore';
import { aiReelStudioParams } from '../studioRoute';
import { AssetViewerItem } from './viewerItems';

/**
 * "Make again" (design a1): the Studio on this asset type of the song, with the params of this
 * version (the "New version" handoff of the Releases card, `setPendingStudioParams`). A reel opens
 * the AI reel form of the song.
 */
export function useMakeAgain(catalogItemUuid: string): (item: AssetViewerItem) => void {
  const router = useSMLRouter();
  return useCallback(
    (item: AssetViewerItem) => {
      if (item.asset === null) {
        router.push(SMLRoutes.promoteStudio, aiReelStudioParams({ catalogItemUuid }));
        return;
      }
      const { themeId, params } = item.asset;
      setPendingStudioParams({ catalogItemUuid, themeId, params });
      router.push(SMLRoutes.promoteStudio, { catalogItemUuid, format: STUDIO_THEMES[themeId].format, theme: themeId });
    },
    [catalogItemUuid, router]
  );
}
